/* Sicilus navigation: native details remain usable without JavaScript. */
(() => {
  const desktop = window.matchMedia('(min-width: 1150px) and (hover: hover)');
  const closeMenu = (menu, restoreFocus = false) => {
    menu.open = false;
    if (restoreFocus) menu.querySelector(':scope > summary')?.focus();
  };
  const init = () => {
    document.querySelectorAll('[data-sicilus-nav]').forEach(menu => {
      if (menu.dataset.sicilusBound) return;
      menu.dataset.sicilusBound = 'true';
      let timer;
      const clear = () => window.clearTimeout(timer);
      menu.addEventListener('mouseenter', () => {
        if (!desktop.matches) return;
        clear();
        timer = window.setTimeout(() => { menu.open = true; }, 220);
      });
      menu.addEventListener('mouseleave', () => {
        clear();
        if (desktop.matches && !menu.contains(document.activeElement)) {
          timer = window.setTimeout(() => closeMenu(menu), 260);
        }
      });
      menu.addEventListener('toggle', () => {
        if (!menu.open) return;
        document.querySelectorAll('[data-sicilus-nav][open]').forEach(other => {
          if (other !== menu) closeMenu(other);
        });
      });
      menu.addEventListener('focusout', event => {
        if (!menu.contains(event.relatedTarget)) closeMenu(menu);
      });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.open) {
          event.preventDefault();
          clear();
          closeMenu(menu, true);
        }
      });
    });
  };
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-sicilus-nav][open]').forEach(menu => {
      if (!menu.contains(event.target)) closeMenu(menu);
    });
  });
  desktop.addEventListener('change', () => {
    document.querySelectorAll('[data-sicilus-nav][open]').forEach(menu => closeMenu(menu));
  });
  document.addEventListener('shopify:section:load', init);
  init();
})();
